// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_ABEQN","red":"index_red_fNrEl","green":"index_green_aqlI-","price":"index_price_04g8t"};